let data = [
    {
        "id": 0,
        "name": "CAPITVLVM I",
        "file": "chapter_1.json",
        "exercises": 11
    },
    {
        "id": 1,
        "name": "CAPITVLVM II",
        "file": "chapter_2.json",
        "exercises": 13
    },
    {
        "id": 2,
        "name": "CAPITVLVM III",
        "file": "chapter_3.json",
        "exercises": 10
    },
    {
        "id": 3,
        "name": "CAPITVLVM IV",
        "file": "chapter_4.json",
        "exercises": 11
    },
    {
        "id": 4,
        "name": "CAPITVLVM V",
        "file": "chapter_5.json",
        "exercises": 11
    },
    {
        "id": 5,
        "name": "CAPITVLVM VI",
        "file": "chapter_6.json",
        "exercises": 12
    },
    {
        "id": 6,
        "name": "CAPITVLVM VII",
        "file": "chapter_7.json",
        "exercises": 11
    },
    {
        "id": 7,
        "name": "CAPITVLVM VIII",
        "file": "chapter_8.json",
        "exercises": 15
    },
    {
        "id": 8,
        "name": "CAPITVLVM IX",
        "file": "chapter_9.json",
        "exercises": 11
    },
    {
        "id": 9,
        "name": "CAPITVLVM X",
        "file": "chapter_10.json",
        "exercises": 11
    },
    {
        "id": 10,
        "name": "CAPITVLVM XI",
        "file": "chapter_11.json",
        "exercises": 13
    },
    {
        "id": 11,
        "name": "CAPITVLVM XII",
        "file": "chapter_12.json",
        "exercises": 20
    },
    {
        "id": 12,
        "name": "CAPITVLVM XIII",
        "file": "chapter_13.json",
        "exercises": 13
    },
    {
        "id": 13,
        "name": "CAPITVLVM XIV",
        "file": "chapter_14.json",
        "exercises": 11
    },
    {
        "id": 14,
        "name": "CAPITVLVM XV",
        "file": "chapter_15.json",
        "exercises": 10
    },
    {
        "id": 15,
        "name": "CAPITVLVM XVI",
        "file": "chapter_16.json",
        "exercises": 12
    },
    {
        "id": 16,
        "name": "CAPITVLVM XVII",
        "file": "chapter_17.json",
        "exercises": 12
    },
    {
        "id": 17,
        "name": "CAPITVLVM XVIII",
        "file": "chapter_18.json",
        "exercises": 16
    },
    {
        "id": 18,
        "name": "CAPITVLVM XIX",
        "file": "chapter_19.json",
        "exercises": 12
    },
    {
        "id": 19,
        "name": "CAPITVLVM XX",
        "file": "chapter_20.json",
        "exercises": 11
    },
    {
        "id": 20,
        "name": "CAPITVLVM XXI",
        "file": "chapter_21.json",
        "exercises": 14
    },
    {
        "id": 21,
        "name": "CAPITVLVM XXII",
        "file": "chapter_22.json",
        "exercises": 10
    },
    {
        "id": 22,
        "name": "CAPITVLVM XXIII",
        "file": "chapter_23.json",
        "exercises": 13
    },
    {
        "id": 23,
        "name": "CAPITVLVM XXIV",
        "file": "chapter_24.json",
        "exercises": 10
    },
    {
        "id": 24,
        "name": "CAPITVLVM XXV",
        "file": "chapter_25.json",
        "exercises": 11
    },
    {
        "id": 25,
        "name": "CAPITVLVM XXVI",
        "file": "chapter_26.json",
        "exercises": 11
    },
    {
        "id": 26,
        "name": "CAPITVLVM XXVII",
        "file": "chapter_27.json",
        "exercises": 12
    },
    {
        "id": 27,
        "name": "CAPITVLVM XXVIII",
        "file": "chapter_28.json",
        "exercises": 12
    },
    {
        "id": 28,
        "name": "CAPITVLVM XXIX",
        "file": "chapter_29.json",
        "exercises": 11
    },
    {
        "id": 29,
        "name": "CAPITVLVM XXX",
        "file": "chapter_30.json",
        "exercises": 13
    },
    {
        "id": 30,
        "name": "CAPITVLVM XXXI",
        "file": "chapter_31.json",
        "exercises": 12
    },
    {
        "id": 31,
        "name": "CAPITVLVM XXXII",
        "file": "chapter_32.json",
        "exercises": 13
    },
    {
        "id": 32,
        "name": "CAPITVLVM XXXIII",
        "file": "chapter_33.json",
        "exercises": 14
    },
    {
        "id": 33,
        "name": "CAPITVLVM XXXIV",
        "file": "chapter_34.json",
        "exercises": 11
    },
    {
        "id": 34,
        "name": "CAPITVLVM XXXV",
        "file": "chapter_35.json",
        "exercises": 3
    }
]
export default data;